import { OutputHTMLElement } from "components/output/baseHTMLElementOutput";
import template from "components/output/baseInputOutput.hbs";
import IMask from "imask";

export class CodeOutputElement extends OutputHTMLElement {

  private mask: IMask.InputMask<IMask.MaskedNumberOptions>;

  constructor() {
    super();

    let className = "c-code-output__output o-form-component__output o-form-component__input-group__input";
    const classCSSOutput = this.getAttribute("classCSSOutput");
    if (classCSSOutput) {
      className += " " + classCSSOutput;
    }

    const optTemplate = {
      "prefixId": "co",
      "id": this.getAttribute("_id"),
      "className": className,
      "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
    } as any;

    this.innerHTML = template(optTemplate);

    this.input = this.querySelector("input");
    this.mask = this.initMask();
  }

  private initMask(): IMask.InputMask<IMask.MaskedNumberOptions> {
    const maskOptions = {
      scale: 0,
      mask: Number,
      min: 0,
      signed: false,
    } as any;
    return IMask(this.input, maskOptions);
  }

  get data(): number {
    let v = this.input.value;
    if (v === "") {
      return null;
    } else {
      return parseInt(v, 10);
    }
  }

  set data(v: number) {
    this.input.value = v?.toString() ?? null;
    this.initialValue.value = this.data;
    this.mask.updateValue();
  }

}

export function initCodeOutputWebComponent() {
  window.customElements.define("s6-code-output", CodeOutputElement);
}
